var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_191210",
    "data-name": "Group 191210",
    xmlns: "http://www.w3.org/2000/svg",
    width: 30.062,
    height: 30.451,
    viewBox: "0 0 30.062 30.451",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_176457",
    "data-name": "Group 176457",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_173779",
    "data-name": "Path 173779",
    d: "M23.262,18.4a9.2,9.2,0,1,0-9.2-9.2,9.212,9.212,0,0,0,9.2,9.2m0-15.951A6.748,6.748,0,1,1,16.514,9.2a6.756,6.756,0,0,1,6.748-6.748",
    transform: "translate(-8.232)",
    fill: "#f26422"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_173780",
    "data-name": "Path 173780",
    d: "M23.619,42.566H20.61V45.02h3.01a3.993,3.993,0,0,1,3.988,3.988v3.911H2.454V49.008A3.993,3.993,0,0,1,6.442,45.02H9.452V42.566H6.442A6.449,6.449,0,0,0,0,49.008v6.365H30.062V49.008a6.449,6.449,0,0,0-6.442-6.442",
    transform: "translate(0 -24.921)",
    fill: "#f26422"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_149273",
    "data-name": "Rectangle 149273",
    width: 21.878,
    height: 2.073,
    transform: "translate(6.243 7.337)",
    fill: "#f26422"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSon);
export default __webpack_public_path__ + "static/media/son.6ae88650494839053be0178e4c7fa490.svg";
export { ForwardRef as ReactComponent };